import React from "react";
import { Popup, Icon } from "semantic-ui-react";

import "./filter_dropdown.css";

const filterOptions = (options, searchTerm) => {
  return options.filter((option) => option.toLowerCase().includes(searchTerm.toLowerCase()));
};

const initialState = {
  isMenuOpen: false,
  isCreateOpen: false,
  createInput: "",
  searchInput: "",
};

function stateReducer(state, action) {
  const newState = { ...state };

  switch (action.type) {
    case "open-menu":
      newState.isMenuOpen = true;
      return newState;
    case "close-menu":
      newState.isMenuOpen = false;
      return newState;
    case "create-open":
      newState.isCreateOpen = true;
      return newState;
    case "create-close":
      newState.isCreateOpen = false;
      newState.createInput = "";
      return newState;
    case "create-save":
      newState.isCreateOpen = false;
      newState.createInput = "";
      return newState;
    case "create-input-change":
      newState.createInput = action.value;
      return newState;
    case "search-input-change":
      newState.searchInput = action.value;
      return newState;
    default:
      return newState;
  }
}

export default function FilterDropdown(props) {
  const contentRef = React.useRef(null);
  const [state, dispatch] = React.useReducer(stateReducer, initialState);

  React.useEffect(() => {
    function handleClickOutside(event) {
      event.stopPropagation();
      if (contentRef.current && !contentRef.current.contains(event.target)) {
        dispatch({ type: "close-menu" });
        if (props.doneable && props.onDone) props.onDone();
      }
    }
    document.addEventListener("onclick", handleClickOutside);
    return () => {
      document.removeEventListener("onclick", handleClickOutside);
    };
  }, []);

  function onClickDropdown(e) {
    e.stopPropagation();
    if (props.disabled) return;
    dispatch({ type: "open-menu" });
  }

  function onSaveNew() {
    dispatch({ type: "create-save" });
    if (props.onSaveNew) props.onSaveNew(state.createInput);
  }

  function onCreateFormSave(data) {
    dispatch({ type: "create-close" });
    if (props.onSaveNew) props.onSaveNew(data);
    if (props.closeOnSelect) dispatch({ type: "close-menu" });
  }

  function onSelect(item) {
    let selections = [...props.selections];
    if (props.singleSelect) {
      selections = [item];
    } else {
      selections.push(item);
    }
    if (props.onChange) props.onChange(selections);
    if (props.closeOnSelect) dispatch({ type: "close-menu" });
  }

  const triggerClass = ["trigger"];
  if (props.className) triggerClass.push(props.className);
  if (props.disabled) triggerClass.push("disabled");

  const CreateForm = props.createForm;
  const optionType = props.singleSelect ? "radio" : "checkbox";
  const filteredOptions = state.searchInput.length > 0 ? filterOptions(props.options, state.searchInput) : props.options;

  return (
    <Popup
      className="filter-dropdown"
      open={state.isMenuOpen}
      trigger={
        props.trigger ? (
          props.trigger
        ) : (
          <a className={triggerClass.join(" ")} onClick={onClickDropdown}>
            {props.label}
          </a>
        )
      }
      onOpen={() => dispatch({ type: "open-menu" })}
      onClose={() => dispatch({ type: "close-menu" })}
      content={
        <div ref={contentRef} className="filter-dropdown-content">
          <div className="content-contanier">
            {!state.isCreateOpen && (
              <React.Fragment>
                <div className="header">
                  {props.header} <Icon name="close" onClick={() => dispatch({ type: "close-menu" })} />
                </div>
                {props.searchable && (
                  <fieldset autoComplete="off" className="input-container">
                    <input
                      type="text"
                      value={state.searchInput}
                      placeholder={props.searchPlaceholder}
                      onChange={(e) =>
                        dispatch({
                          type: "search-input-change",
                          value: e.target.value,
                        })
                      }
                      autoFocus
                    />
                  </fieldset>
                )}
                <div className="options">
                  {props.isLoading && (
                    <div className="option">
                      <Icon name="circle notch" loading />
                    </div>
                  )}
                  {state.searchInput.length > 0 && filteredOptions.length === 0 && <div className="option">No match found</div>}
                  {!props.isLoading &&
                    filteredOptions.map((option) => (
                      <div className="option" key={`option-${option}`} onClick={() => onSelect(option)}>
                        <input type={optionType} checked={props.selections && props.selections.includes(option)} readOnly></input>
                        <div className="option-label">{option}</div>
                      </div>
                    ))}
                </div>
              </React.Fragment>
            )}
            {state.isCreateOpen && (
              <div style={{ marginTop: "1rem" }}>
                <CreateForm onSave={onCreateFormSave} onClose={() => dispatch({ type: "create-close" })} />
              </div>
            )}
            {state.isCreateOpen && !CreateForm && (
              <React.Fragment>
                <div className="input-container">
                  <input
                    type="text"
                    value={state.createInput}
                    placeholder={props.newPlaceholder}
                    onChange={(e) =>
                      dispatch({
                        type: "create-input-change",
                        value: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="create-actions">
                  <div className="action" onClick={onSaveNew}>
                    Save
                  </div>
                  <div className="action" onClick={() => dispatch({ type: "create-close" })}>
                    Cancel
                  </div>
                </div>
              </React.Fragment>
            )}
            <div className="footer">
              {props.addable && !state.isCreateOpen && (
                <div className="action" onClick={() => dispatch({ type: "create-open" })}>
                  Create New
                </div>
              )}
            </div>
          </div>
        </div>
      }
      on="click"
      position="bottom left"
      basic
      hideOnScroll
      verticalOffset={-8}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/filter_dropdown/filter_dropdown.js